<template>
  <el-row
    type="flex"
    justify="space-around"
    :gutter="9"
    class="container"
  >
    <base-card
      v-bind:path="newSwapPath"
      v-bind:card-message="newSwapMessage"
    />
    <base-card
      v-bind:path="existingSwapPath"
      v-bind:card-message="existingSwapMessage"
    />
  </el-row>
</template>

<script>
import '../components/BaseCard.vue';

export default {
  name: 'HomePage',
  data() {
    return {
      newSwapMessage: 'New Swapper',
      newSwapPath: 'new-customer',
      existingSwapMessage: 'Existing Swapper',
      existingSwapPath: 'search'
    };
  }
};
</script>

<style scoped>
  .container {
    padding: 0 6vw 0 6vw;
  }
</style>